/**
 * @file ChangeShowInactiveGroups
 */

'use strict';

/**
 * @classname ChangeShowInactiveGroups
 * @classdesc 休止中地域含む地域取得
 */
export default class ChangeShowInactiveGroups {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('#show_inactive_groups');
	 */
	constructor($e, controller) {
		console.log(`ChangeShowInactiveGroups.constructor`);
		this._$e = $e;
		this._controller = controller;
		this._$e.on('click', () => this.onClick());
		this._controller.on('getDistrictsComplete', () => this.setDistricts());
	}


	/**
	 * 'click' のコールバック
	 *
	 * @memberof ChangeShowInactiveGroups
	 * @return {undefined}
	 */
	onClick() {
		console.log(`ChangeShowInactiveGroups.onClick`);
		const $council = $('[data-search-item=council_id]');
		const councilId = $council.val();
		console.log(councilId);
		if(councilId === '') return;
		if(this._$e.prop('checked')) {
			this._controller.getDistricts(councilId, true);
		} else {
			this._controller.getDistricts(councilId);
		}
	}

	/**
	 * 地区設定
	 *
	 * @memberof ChangeShowInactiveGroups
	 * @return {undefined}
	 */
	setDistricts() {
		console.log(`ChangeShowInactiveGroups.setDistricts`);
		console.log(this._controller._districts);
		if ($('.council_id').val() === '') {
			$('.district_id').html('<option value="">--</option>');
		} else {
			$('.district_id').html(this.createOptions(this._controller._districts));
		}
	}
	/**
	 * option生成
	 *
	 * @memberof ChangeCouncil
	 * @return {undefined}
	 */
	createOptions(items) {
		console.log(`ChangeCouncil.createOptions`);
		let options = '<option value="">▼選択</option>';
		items.forEach(item => options += `<option value='${item.id}'>${item.name}</option>`);
		return options
	}
}
